import React from 'react'
import {
  Typography
} from '@material-ui/core'
import Modal from 'components/Modal'
import useStyles from './styles'


const AreYouSureModal = (props) => {
  const {
    setShowDialog,
    showDialog,
    actionText,
    primaryActionClass,
    action,
    actionDescription,
    header
  } = props


  const localClasses = useStyles()

  return (
    <Modal
      open={showDialog}
      onClose={() => setShowDialog(false)}
      header={header || 'Confirm'}
      action={action}
      actionText={actionText || 'Submit'}
      maxWidth='sm'
      primaryActionClass={primaryActionClass}
      secondaryAction={() => setShowDialog(false)}
      dialogActionsClass={localClasses.dialogActionsClass}
      additionalContentClasses={localClasses.additionalContentClasses}
    >
      <Typography variant='body2' color='textSecondary' className={localClasses.actionDescription}>
        { actionDescription || 'Are you sure?' }
      </Typography>
    </Modal>
  )
}

export default AreYouSureModal
